"use client";

import styles from "../../HeroSubBannerJob/HeroSubBannerJob.module.scss"
import Image from "next/image";
import { useEffect, useRef } from "react";
import { pushToDataLayer } from "@/helpers/gtag";
import { useModalDispatch } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import { useRouter } from "next/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { NEXT_PUBLIC_IMAGE_PATH_V5 } from "@/components/atoms/LeadTheFutureCareerPage/utils";


const IMG_BASE_URL = process.env.NEXT_PUBLIC_NEW_IMAGE_PATH;
interface SubBannerContentProps {
  associatedPrograms: any;
  Brochure?: {
    data?: {
      attributes?: {
        url?: string;
      };
    };
  };
}

const CourseName = ({ ProgramHeading , isProgram= false,}) => {
  return (
    <>
     
     <div className={styles.course_name} dangerouslySetInnerHTML={{ __html: ProgramHeading }} />
     
     </>
  );
};

const CourseNameCard = ({ Cards, isMobile ,isProgram=false}) => {
  const router = useRouter();
  const staticData = [
    {
      image: 'https://amityonline.com/_s/MBA_program_bed9c5def5.webp',
      Title: 'MBA',
      Subtitle: '14 Specializations',
      url_key: 'master-of-business-administration-online'
    },
    {
      image: 'https://amityonline.com/_s/BBA_0b50e97a68.webp',
      Title: 'BBA',
      Subtitle: '2 Specializations',
      url_key: 'bachelor-of-business-administration-online'
    },
    {
      image: 'https://amityonline.com/_s/MCA_7b9c4e6332.webp',
      Title: 'MCA',
      Subtitle: '6 Specializations',
      url_key: 'master-of-computer-applications-online'
    },
    {
      image: 'https://amityonline.com/_s/BCA_5bdf56f8db.webp',
      Title: 'BCA',
      Subtitle: '6 Specializations',
      url_key: 'bachelor-of-computer-applications-online'
    },
    {
      image: 'https://amityonline.com/_s/BCA_in_Fintech_2afc943c61.webp',
      Title: 'BCA',
      Subtitle: 'Fintech & AI',
      url_key: 'bca-fintech-ai-paytm'
    },
    {
      url_key: "mba-construction-project-management",
      Title: "MBA",
      Subtitle: "Construction Project Mgmt.",
      image:  "https://amityonline.com/_s/4732cbe5954496331f88cdce8bff18293a14b0b1_14f6d7af18.webp"
    },
    {
      url_key: "mba-hospital-healthcare-management",
      Title: "MBA",
      Subtitle: "Healthcare Mgmt.",
      image: "https://amityonline.com/_s/MBA_in_Healthcare_Management_0c861b2b11.webp"
    }
  ]

  const data = (Cards && Cards.length) ? Cards : staticData;



  if (!data.length) return null;

  // for Dynamic
  const CardUI = ({ item, ind }) => (
    <div
      key={ind}
      onClick={() => router.push(`/${item?.url_key}`)}
      className="flex flex-col items-center bg-[#1f325D] cursor-pointer rounded-2xl border border-yellow-400 overflow-hidden  w-full "
    >
      <div className="w-full  h-[108px] overflow-hidden">
        <img
          src={isProgram ? item?.image : `${item?.rightImage?.url}`}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex flex-col items-center py-2">
        <h2
          className="text-white text-[20px] font-normal leading-[20px]"
          style={{ fontFamily: "var(--font-baskervville)" }}
        >
          {item?.Title}
        </h2>
        <p
          className="text-[12px] leading-[147%] font-semibold text-center tracking-normal text-white"
          style={{ fontFamily: "var(--font-raleway)" }}
        >
          {" "}
          {item.Subtitle}
        </p>
      </div>
    </div>
  );


    return (
      <div className="my-4">
        <Swiper
        modules={[Autoplay]}
        slidesPerView={4}
        loop={data.length>4?true:false}
        speed={800}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        roundLengths={true}
        className={styles.swiper_container}
        breakpoints={{
          320: {
            slidesPerView: 2,
          },
          350: {
            slidesPerView: 2,
            spaceBetween: 5
          },
          450: {
            slidesPerView: 3,
            spaceBetween: 5
          },
          500: {
            slidesPerView: 3,
            spaceBetween: 5
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 5
          },
          820: {
            slidesPerView: 4,
            spaceBetween: 5
          }
        }}
      >
        {
          data?.map((item, index) => {
            return (
              <SwiperSlide key={index} className={styles.slide}>
                  <CardUI item={item}ind={index}
                  />
              </SwiperSlide>
            );
          })
        }
      </Swiper>
      </div>
    );
};

const BrouchreDownloadContainer = ({
  associatedPrograms,
  Brochure = {},
}: SubBannerContentProps)=> {
  const modalDispatch = useModalDispatch();
const BrochureLink=Brochure?.data?.attributes?.url
  const downloadBrochurePopup = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalMba,
        modalData: {
          rfiCase: "DOWNLOAD_BROCHURE_CASE",
          attachmentURL: BrochureLink,
          associatedPrograms,
          modalVariant: "downloadBrochure",
          isJobRole:true   
        },
      },
    });

    setTimeout(()=> {
      updateStateSession({ leadStartingCta: "Download Brochure", parentSection: "hero_banner" });
      pushToDataLayer({
            event: "lead_initiate",
            cta_text: "Download Brochure",
            section_name: "hero_banner",
            page_type: getGlobalStateValue("pageType"),
            page_url_custom: location.href,
          });

    },2000)

  };
  
  return (
    <div className={styles.brochure_container}>
      <button onClick={downloadBrochurePopup} className={styles.download_br}>
        download brochure
        <Image
          src={IMG_BASE_URL + "_s/down_arrow_db_2b837a8c53.svg"}
          width={26}
          height={26}
          alt="download brochure logo"
        />
      </button>
    </div>
  );
};


const Jobbanner = ({ isMobile = false, isDownload=false, isProgram= false, BannerImageTemplete, associatedPrograms,Brochure={} }) => {
   return (
    <div className={styles.content_container}>
      <CourseName ProgramHeading={BannerImageTemplete?.Title} isProgram={isProgram} />
      <div className="text-white lg:text-[1rem] text-[.75rem] text-start font-medium mt-2" style={{fontFamily:"var(--font-raleway)"}} dangerouslySetInnerHTML={{ __html: BannerImageTemplete?.Subtitle }} />
        <CourseNameCard Cards={BannerImageTemplete?.CourseName} isMobile={isMobile} isProgram={isProgram} />
        {!isDownload &&
       <BrouchreDownloadContainer Brochure={Brochure} associatedPrograms={associatedPrograms} />
        }
    </div>
  );
};

export default Jobbanner;



